export const AUTH_SESSION_TIMEOUT_MS = 12_000;
export const MFA_GATE_TIMEOUT_MS = 10_000;
export const API_FETCH_TIMEOUT_MS = 15_000;
export const BOOTSTRAP_TIMEOUT_MS = 20_000;
export const LOADING_RECOVERY_MS = 15_000;
export const APP_INIT_TIMEOUT_MS = 8_000;
export const HASH_BOOTSTRAP_TIMEOUT_MS = 8_000;

export class TimeoutError extends Error {
  constructor(message = "Operation timed out") {
    super(message);
    this.name = "TimeoutError";
  }
}

/** Reject if `promise` does not settle within `ms`. */
export function withTimeout<T>(
  promise: PromiseLike<T>,
  ms: number,
  message?: string,
): Promise<T> {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(new TimeoutError(message ?? `Timed out after ${ms}ms`));
    }, ms);

    Promise.resolve(promise).then(
      (value) => {
        clearTimeout(timer);
        resolve(value);
      },
      (err) => {
        clearTimeout(timer);
        reject(err);
      },
    );
  });
}

export async function fetchWithTimeout(
  input: RequestInfo | URL,
  init?: RequestInit,
  timeoutMs = API_FETCH_TIMEOUT_MS,
): Promise<Response> {
  return withTimeout(
    fetch(input, init),
    timeoutMs,
    "Network request timed out",
  );
}
